import { ListPageSkeleton } from '@practium/ui';

export const SystemPageSkeleton = () => (
	<ListPageSkeleton
		tabsCount={3}
		sidebarWidth="28rem"
		sidebarW1500="22rem"
		sidebarW1300="19rem"
		sidebarW1200="17rem"
		sidebarCardsCount={1}
	/>
);
